import { CompanyRepository } from "core/repository";
import { Base2Presenter } from "core/presenter";
import uuid from "uuid";

class PaymentsPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: false,
      payments: [],
      errors: [],
      title: "Pagamentos"
    };
  }

  async onStart() {
    this.enqueue({ loading: true });

    await this.loadPayments();

    this.enqueue({ loading: false });
  }

  async loadPayments() {
    const currentUser = await this.mRuntime.get("currentUser");
    const paymentsResult = await CompanyRepository.getOnline(
      currentUser.company_uuid
    );

    if (paymentsResult.success) {
      this.enqueue({
        payments: paymentsResult.data.custom_other_payments || []
      });
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content:
          "Não conseguimos carregar os dados! Por favor, tente novamente em alguns minutos ou entre em contato com o suporte."
      });
    }
  }

  async onSendForm() {
    this.enqueue({ loading: true });

    const payments = this.viewModel.payments;
    const validation = this.validatePayments(payments);

    if (validation.valid) {
      payments.forEach(p => {
        if (!p.use_note) {
          p.use_note = false;
        }
        delete p.createdNow;
      });

      const currentUser = await this.mRuntime.get("currentUser");
      const response = await CompanyRepository.update(
        currentUser.company_uuid,
        { custom_other_payments: payments }
      );

      if (response.success) {
        this.enqueue({ errors: [] });

        this.sendNotification({
          type: "success",
          content: "Pagamentos salvos com sucesso!"
        });
      } else {
        this.sendNotification({
          type: "error",
          title: "Oops...",
          content:
            "Ocorreu um problema ao salvar os pagamentos. Verifique os dados informados e se os campos marcados com * estão preenchidos."
        });
      }
    } else {
      this.enqueue({ errors: validation.errors });

      this.sendNotification({
        type: "error",
        title: "Oops...",
        content:
          "Ocorreu um problema ao salvar os pagamentos. Verifique os dados informados e se os campos marcados com * estão preenchidos."
      });
    }

    this.enqueue({ loading: false });
  }

  validatePayments(payments) {
    const errors = [];
    const allDescriptions = [];

    payments.forEach(payment => {
      allDescriptions.push(payment.label);
      let label = "";

      if (!payment.label) {
        label = "Descrição é obrigatório";
      } else if (payment.label && payment.label.length > 15) {
        label = "Descrição deve ter menos de 15 caracteres.";
      } else {
        label = "";
      }

      errors.push({
        uuid: payment.uuid,
        label,
        type:
          payment.payment_type === "none" || !payment.payment_type
            ? "Tipo de Pagamento é obrigatório"
            : ""
      });
    });

    const duplicatedIndexes = this.getDuplicatedDescriptionsIndexes(
      allDescriptions
    );

    duplicatedIndexes.forEach(di => {
      errors[di].label = "Descrição duplicada. Cadastre uma nova descrição.";
    });

    const valid = errors.filter(error => error.label || error.type);

    return { errors, valid: valid.length === 0 ? true : false };
  }

  getDuplicatedDescriptionsIndexes(array) {
    const descriptions = {};
    let result = [];

    array.forEach((item, i) => {
      if (!descriptions[item]) {
        descriptions[item] = [];
      }
      descriptions[item].push(i);
    });

    for (const desc in descriptions) {
      if (descriptions[desc].length >= 2 && desc !== "") {
        result = result.concat(descriptions[desc]);
      }
    }

    return result;
  }

  handleNewPayment() {
    this.enqueue(vm => ({
      payments: [
        ...vm.payments,
        {
          uuid: uuid(),
          label: "",
          payment_type: "none",
          enabled: true,
          createdNow: true,
          use_note: false
        }
      ]
    }));
  }

  onChange(index, field, value) {
    this.enqueue(vm => {
      const payments = vm.payments;
      payments[index][field] = value;

      return { payments };
    });
  }

  onDeletePayment(index) {
    this.enqueue(vm => {
      const payments = vm.payments;
      payments.splice(index, 1);

      return { payments };
    });
  }
}

export default PaymentsPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/payment/presenter.js